var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all"},[_c('img',{staticClass:"title",attrs:{"src":require("../assets/img/title.png")}}),_c('vs-alert',{attrs:{"color":_vm.color},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" 错误: "+_vm._s(_vm.msg)+" ")]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }